export default __webpack_public_path__ + "static/media/fun_mar2020.095b66c9.bmp";